export const gridCellSelectionStateSelector = state => state.cellSelection;